import axios from "axios";
import { API_URL } from "../config/constants";


const axiosAUTHAPI = axios.create(
{  
        baseURL: API_URL,
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
    });

export default axiosAUTHAPI;
